import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@talentech/components';

interface IFontResponse {
  id: string;
  name: string;
  slug: string;
  variants: {
    filename: string;
    format: string;
    weight: number;
    italic: boolean;
    url: string;
  }[];
  css_url: string;
}

export const fontsApi = createApi({
  reducerPath: 'fontsApi',
  baseQuery: axiosBaseQuery({ baseUrl: process.env.API_URL as string }),
  tagTypes: ['Fonts'],
  endpoints: (builder) => ({
    getFonts: builder.query<IFontResponse[], void>({
      query: () => ({
        url: '/fonts/',
      }),
      providesTags: ['Fonts'],
    }),
    uploadFont: builder.mutation<any, FormData>({
      query: (payload) => {
        return {
          url: '/fonts/',
          method: 'POST',
          data: payload,
        };
      },
      invalidatesTags: ['Fonts'],
    }),
    deleteFont: builder.mutation<any, string>({
      query: (id) => ({
        url: `/fonts/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Fonts'],
    }),
  }),
});

export const { useGetFontsQuery, useUploadFontMutation, useDeleteFontMutation } = fontsApi;
